import { createContext } from 'react';

const aboutusContext = createContext();

export default aboutusContext;